import { apiClient } from '@/services/api';
import { logger } from '@/utils/logger/loggerInstance';

/**
 * Structured tool result attached to an assistant message. The chat UI
 * renders these inline (POI grid, etc.) below the text, ordered by
 * `index` relative to the streaming text chunks.
 */
export interface AskHauserToolResult {
  toolName: string;
  toolInput: Record<string, unknown>;
  result: unknown;
  index: number;
}

export interface AskHauserMessage {
  conversationKey: string;
  createdAt: number;
  messageId: string;
  propertyId: string;
  userId: string;
  role: 'user' | 'assistant';
  content: string;
  toolResults?: AskHauserToolResult[];
  inputTokens?: number;
  outputTokens?: number;
  model?: string;
}

export interface GetAskHauserHistoryResponse {
  messages: AskHauserMessage[];
  nextCursor?: string;
}

export type AskHauserMode = 'homeowner' | 'buyer';

export const sendAskHauserMessage = async (
  propertyId: string,
  content: string,
  propertyContext?: Record<string, unknown>,
  mode?: AskHauserMode,
): Promise<{ messageId: string }> => {
  const url = `/ask-hauser/${propertyId}/messages`;
  logger.debug(`POST ${url}`);
  const payload: Record<string, unknown> = { content };
  if (propertyContext) payload.propertyContext = propertyContext;
  if (mode) payload.mode = mode;
  const response = await apiClient.post<{ messageId: string }>(url, payload);
  return response.data;
};

export const getAskHauserHistory = async (
  propertyId: string,
  cursor?: string,
): Promise<GetAskHauserHistoryResponse> => {
  const url = `/ask-hauser/${propertyId}/messages`;
  const params = cursor ? { cursor } : {};
  logger.debug(`GET ${url}`);
  const response = await apiClient.get<GetAskHauserHistoryResponse>(url, { params });
  return response.data;
};

export const clearAskHauserHistory = async (propertyId: string): Promise<void> => {
  const url = `/ask-hauser/${propertyId}/messages`;
  logger.debug(`DELETE ${url}`);
  await apiClient.delete(url);
};
